export const MASTER_USERNAME_FIELD = "username";
export const MASTER_PASSWORD_FIELD = "newPassword";
export const MASTER_CONFIRM_PASSWORD_FIELD = "reEnterPassword";
export const MASTER_PASSWORD_LOCK_FIELD = "passwordLock";
